import type { FC } from 'react'

export const LogoIcon: FC = () => {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3344_38"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <circle cx="12" cy="12" r="12" fill="#F769EA" />
      </mask>
      <g mask="url(#mask0_3344_38)">
        <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_3344_38)" />
        <g filter="url(#filter0_f_3344_38)">
          <ellipse
            cx="17.53"
            cy="0.529999"
            rx="16.53"
            ry="16.53"
            fill="url(#paint1_linear_3344_38)"
          />
        </g>
        <g filter="url(#filter1_f_3344_38)">
          <circle cx="0.899994" cy="30.66" r="12" fill="url(#paint2_linear_3344_38)" />
        </g>
        <g filter="url(#filter2_f_3344_38)">
          <circle cx="17.28" cy="25.68" r="3.3" fill="url(#paint3_linear_3344_38)" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_3344_38"
          x="-3"
          y="-20"
          width="41.06"
          height="41.0601"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_3344_38" />
        </filter>
        <filter
          id="filter1_f_3344_38"
          x="-95.1"
          y="-65.34"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="42" result="effect1_foregroundBlur_3344_38" />
        </filter>
        <filter
          id="filter2_f_3344_38"
          x="-70.02"
          y="-61.62"
          width="174.6"
          height="174.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="42" result="effect1_foregroundBlur_3344_38" />
        </filter>
        <linearGradient
          id="paint0_linear_3344_38"
          x1="2.82"
          y1="5.1"
          x2="19.02"
          y2="22.14"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#A55FF2" />
          <stop offset="0.354167" stopColor="#F08EFF" />
          <stop offset="1" stopColor="#F86ADE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3344_38"
          x1="16.75"
          y1="-0.160001"
          x2="17.53"
          y2="17.06"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5EE8FF" />
          <stop offset="1" stopColor="#007FFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3344_38"
          x1="0.899994"
          y1="23.94"
          x2="0.899994"
          y2="42.66"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#007FFF" />
          <stop offset="1" stopColor="#5EE8FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3344_38"
          x1="17.28"
          y1="23.832"
          x2="17.28"
          y2="28.98"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#007FFF" />
          <stop offset="1" stopColor="#5EE8FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
